import React from 'react'
import PanelToggle from './index'

function Facets({ facets = [], enrolledIn, orgNames, orgTypes}) {
  return (
    <PanelToggle
      content={facets}
      enrolledIn={enrolledIn}
      orgNames={orgNames}
      orgTypes={orgTypes}
    />
  )
}

export default Facets
